import React, { useEffect, useState } from "react";
import { DesktopTimePicker, TabContext, TabList, TimePicker } from "@mui/lab";
import { MobileTimePicker } from "@mui/x-date-pickers/MobileTimePicker";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  Radio,
  RadioGroup,
  Switch,
  Tab,
  TextField,
  Typography,
} from "@mui/material";

import AutoCompleteMultiSelect from "../../../components/AutoCompleteMultiselect/AutoCompleteMultiSelect.tsx";
import TextAreaComponents from "../../../components/TextAreaComponents/TextAreaComponents.tsx";
import { ToastContainer, toast } from "react-toastify";
import Cancel from "./../../../../assets/icons/close.png";

import LoadingView from "../../../components/LoadingView/LoadingView.js";
import SweetAlertModal from "../../../components/SweetAlertModal/SweetAlertModal.js";
import axios from "axios";
import jwt_decode from "jwt-decode";

function VATEditDialog(props) {
  console.log("im props", props);
  // const { title } = props.title
  //Addsection dialog control start
  const [openAddKeyword, setOpenAddKeyword] = useState(false);

  const [openAddSection, setOpenAddSection] = useState(false);
  const [dialogType, setDialogType] = useState("");
  const [VatName, setVatName] = useState("");
  const [Parcentage, setParcentage] = useState(0);
  const [dataRows, setDataRows] = useState([]);

  const [openConfirmaitonModal, setopenConfirmaitonModal] = useState(false);

  const [loadingModal, SetloadingModal] = React.useState(false);
  const handleClose = () => {
    setopenConfirmaitonModal(false);
    props.onHandleAddItem(false);
  };

  const [vatSetupView, setvatSetupView] = useState({
    Id: "",
    Name: "",
    Percentage: 0,
    RestaurantId: "",
    CreatorId: "",
    CreationDate: "05-02-2024",
    ModifierId: "",
    ModificationDate: "05-02-2024",
  });

  //AddSpecification modal open functionality
  const [open, setOpen] = useState(false);

  //Addsection dialog controll end

  //image upload code start

  //image upload code end
  const restaurant = JSON.parse(localStorage.getItem("restaurant"));

  const [autoCompleteValue, setAutoCompleteValue] = React.useState([]);
  const [specificationRows, setSpecificationRows] = React.useState([]);
  const [tokenData, setTokenData] = useState({});
  const apiAddress = process.env.REACT_APP_SECRET;

  const loadData = async () => {
    axios({
      method: "get",
      url: apiAddress + "/api/Vat/GetVatByIdAsync?Id=" + props.selectedId,
    })
      .then((response) => {
        console.log(response);
        var vatData = response.data[0];
        setVatName(vatData.name);
        setParcentage(vatData.percentage);

        vatSetupView.CreatorId = vatData.creatorId;
        vatSetupView.CreationDate = vatData.creationDate;

        console.log(vatData.name);
        console.log(vatData.percentage);
        var list = [];
        response.data.map((dt, i) => {
          var obj = {
            id: dt.id,
            name: dt.name,
            percentage: dt.percentage,
            restaurantId: dt.restaurantId,
          };
          list.push(obj);
        });
        setDataRows(list);
        console.log(list);
      })
      .catch((error) => {});
  };

  useEffect(() => {
    loadData();
  }, [props]);

  const update = () => {
    const token = localStorage.getItem("gotasteadmintoken");

    var decodedData = {};
    if (token != null) {
      try {
        decodedData = jwt_decode(token);
        setTokenData(decodedData);
        var obj = {
          id: decodedData.UserId,
          title: decodedData.UserName,
        };
        var list = [];
        list.push(obj);
      } catch (error) {}
    }

    vatSetupView.Id = props.selectedId;
    vatSetupView.Name = VatName;
    vatSetupView.Percentage = Parcentage;
    vatSetupView.RestaurantId = restaurant.id;
    vatSetupView.CreatorId = vatSetupView.CreatorId;
    vatSetupView.CreationDate = vatSetupView.CreationDate;
    vatSetupView.ModifierId = decodedData.UserId;
    vatSetupView.ModificationDate = new Date().toISOString();

    var valid = true;

    if (!!VatName == false) {
      toast.error("Vat Name Is required", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      console.log("hit");
      valid = false;
    }
    if (!!Parcentage == false) {
      toast.error("Value is required", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      console.log("hit");
      valid = false;
    }

    if (valid) {
      SetloadingModal(true);
      console.log("Api hit");

      axios({
        method: "put",
        url: apiAddress + "/api/Vat/" + props.selectedId,
        data: vatSetupView,
      })
        .then((response) => {
          console.log(response);
          SetloadingModal(false);
          toast.success("Successfully Updated", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });

          setopenConfirmaitonModal(false);
          props.onHandleAddItem(false);
        })
        .catch((error) => {
          console.log(error);
          toast.error(error.response, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    }
    setopenConfirmaitonModal(false);
  };

  const closeLoadingModal = () => {
    SetloadingModal(false);
  };


  return (
    <div>
      <React.Fragment>
        <Dialog fullWidth={true} open={props.open} onClose={handleClose}>
          <LoadingView open={loadingModal} close={closeLoadingModal} />
          <SweetAlertModal
            headerText={"Are you sure?"}
            bodyText={"You want to update this?"}
            open={openConfirmaitonModal}
            onyes={update}
            close={() => {
              setopenConfirmaitonModal(false);
            }}
          />
          <ToastContainer />
          <Grid container>
            <Grid item xs={6}>
              <DialogTitle>Update VAT</DialogTitle>
            </Grid>
            <Grid item xs={6}>
              <DialogActions>
                <Button onClick={handleClose}>
                  <img src={Cancel} alt="Close" style={{ width: "1.2rem" }} />
                </Button>
              </DialogActions>
            </Grid>
          </Grid>
          <div style={{ padding: "10px" }}>
            <Grid container sx={{ padding: "0.5rem" }}>
              <Grid item xs={2}>
                <Typography style={{ paddingTop: "1rem" }}>Vat Name</Typography>
              </Grid>
              <Grid item xs={10}>
                <TextAreaComponents
                  label={"Vat name"}
                  value={setVatName}
                  val={VatName}
                ></TextAreaComponents>
              </Grid>
            </Grid>
            <Grid container sx={{ padding: "0.5rem" }}>
              <Grid item xs={2}>
                <Typography style={{ paddingTop: "1rem" }}>
                  Percentage
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <TextAreaComponents
                  id={2}
                  label={"Percentage"}
                  value={setParcentage}
                  val={Parcentage}
                ></TextAreaComponents>
              </Grid>
            </Grid>

            <Grid container sx={{ padding: "0.5rem" }}>
              <Grid item xs={9}></Grid>
              <Grid item xs={2}>
                <Button
                  className="AddItemButtons"
                  onClick={() => setopenConfirmaitonModal(true)}
                >
                  Update
                </Button>
              </Grid>
              <Grid item xs={1}></Grid>
            </Grid>
          </div>
          {/* <DialogActions>
            <Button onClick={handleClose}>Close</Button>
          </DialogActions> */}
        </Dialog>
      </React.Fragment>
    </div>
  );
}

export default VATEditDialog;
